import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"20px","text-align":"right"} }

import { h, reactive, ref, onMounted, unref } from 'vue';
import { useRouter } from 'vue-router';

import { ElButton, ElTag } from 'element-plus';
import moment from 'moment';

/* Components */
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { useLocales } from '@/hooks/useLocales';
import CompanyWriter from './components/CompanyWriter.vue';

/* API */
import { GetCompanyListApi, CompanyDeleteApi } from '@/apis/basics/companys/apis';

/* Dtos */
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { CompanyDeleteDto } from '@/apis/basics/companys/dtos';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();

const companyRef = ref<ComponentRef<typeof CompanyWriter>>();

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<any>({
	getListApi: GetCompanyListApi,
	delListApi: CompanyDeleteApi,
	response: { data: 'data', total: 'total' },
});

const { setSearchParams } = methods;

/* 数据Table绑定设置 */
const tabColumns = reactive<any[]>([
	{ field: 'prefix_no', label: t('basics.companys.table.prefix', '前缀'), columnWidth: '60' },
	{ field: 'cmp_code', label: t('basics.companys.table.code', '编号'), columnWidth: '120' },
	{ field: 'cmp_name', label: t('basics.companys.table.name', '名称'), columnWidth: '280' },
	{ field: 'short_name', label: t('basics.companys.table.shortName', '简称'), columnWidth: '160' },
	{ field: 'business_code', label: t('basics.companys.table.erpCode', 'Erp编号'), columnWidth: '120' },
	{ field: 'address', label: t('basics.companys.table.address', '地址') },
	{ field: 'sort', label: t('basics.companys.table.sort', '排序'), columnWidth: '80', align: 'center' },
	{ field: 'is_enabled', label: t('basics.companys.table.status', '状态'), columnWidth: '80', align: 'center' },
	{ field: 'created_time', label: t('basics.companys.table.createdTime', '创建时间'), columnWidth: '120', fixed: 'right', align: 'center' },
	{ field: 'action', width: '120px', label: t('basics.companys.table.actions', '操作'), fixed: 'right', align: 'center' },
]);

const state = reactive({
	loading: false,
	search: {} as any,
	paged: { current: 1, page_size: 20 },
});

const actions = {
	search: () => {
		const searchInput = Object.assign({}, state.search, state.paged);
		methods.setSearchParams(searchInput);
	},
	reSetSearch: () => {
		state.search = {};
		methods.resetParams(state.search);
	},
	/* 创建 */
	create: () => {
		unref(companyRef)?.create();
	},

	/* 编辑*/
	modify: (row: any) => {
		unref(companyRef)?.editor(row.id);
	},

	/* 删除 */
	delete: async (row: any) => {
		const deleteDto: CompanyDeleteDto = { id: row.id, revision: row.revision };
		await methods.deleteRows(deleteDto);
	},
};

onMounted(async () => {
	tableObject.pageSize = 20;
	actions.search();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(state).search,
          inline: true,
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('basics.companys.search.companyCode', '公司编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).search.cmp_code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.cmp_code) = $event)),
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('basics.companys.search.companyName', '公司名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).search.cmp_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).search.cmp_name) = $event)),
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "Refresh",
                      onClick: actions.reSetSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('basics.companys.search.buttons.reset', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      icon: "Search",
                      onClick: actions.search
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('basics.companys.search.buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(ElButton), {
            size: "small",
            type: "warning"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('basics.companys.search.buttons.syncData', '同步数据')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            size: "small",
            type: "primary",
            onClick: actions.create
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('basics.companys.search.buttons.createAccountSet', '创建账套')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY/MM/DD HH:mm')), 1)
          ]),
          is_enabled: _withCtx(({ row }) => [
            (row.is_enabled == 'Y')
              ? (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 0,
                  size: "small",
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('basics.companys.options.enabled', '启用')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (row.is_enabled == 'N')
              ? (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 1,
                  size: "small",
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('basics.companys.options.disabled', '停用')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          action: _withCtx(({ row }) => [
            _createVNode(_unref(ElButton), {
              size: "small",
              type: "success",
              link: "",
              onClick: ($event: any) => (actions.modify(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('basics.companys.buttons.edit', '编 辑')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_unref(ElButton), {
              size: "small",
              type: "danger",
              link: "",
              onClick: ($event: any) => (actions.delete(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('basics.companys.buttons.delete', '删 除')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }),
    _createVNode(CompanyWriter, {
      ref_key: "companyRef",
      ref: companyRef,
      onRefresh: actions.search
    }, null, 8, ["onRefresh"])
  ], 64))
}
}

})